import React, { useCallback, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { Breadcrumb, Button, Card, Form } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'
import { getMinBankWithdraw, updateMinBankWithdraw } from '../../../../controller/api/withdrawSetting'

const MAX_AMOUNT = 1000000000

export default () => {
  const [cookies] = useCookies(['lottmekong'])
  const [loaded, setLoaded] = useState(false)
  const [saving, setSaving] = useState(false)
  const [amountInput, setAmountInput] = useState('200000')
  const [savedAmount, setSavedAmount] = useState(200000)
  const [error, setError] = useState('')
  const [saved, setSaved] = useState(false)

  const load = useCallback(async () => {
    setLoaded(false)
    setSaved(false)
    setError('')
    try {
      const amount = await getMinBankWithdraw(cookies.lottmekong)
      const next = Number.isFinite(amount) && amount > 0 ? amount : 200000
      setSavedAmount(next)
      setAmountInput(String(next))
    } catch (e) {
      setError('Không tải được mức rút ngân hàng')
    }
    setLoaded(true)
  }, [cookies.lottmekong])

  useEffect(() => {
    document.title = 'Cài đặt rút tiền'
    load()
  }, [load])

  const onSave = async () => {
    const amount = Number(String(amountInput).trim())
    if (!Number.isSafeInteger(amount) || amount < 1 || amount > MAX_AMOUNT) {
      setError('Nhập số tiền nguyên từ 1 đến 1.000.000.000')
      setSaved(false)
      return
    }
    setError('')
    setSaved(false)
    setSaving(true)
    const resp = await updateMinBankWithdraw(cookies.lottmekong, amount)
    if (resp && resp.error) {
      setError(resp.message || 'Không lưu được mức rút ngân hàng')
    } else if (resp && resp.status === 'success') {
      setSavedAmount(resp.minBankWithdraw)
      setAmountInput(String(resp.minBankWithdraw))
      setSaved(true)
    } else {
      setError('Không lưu được mức rút ngân hàng')
    }
    setSaving(false)
  }

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: 'breadcrumb-dark breadcrumb-transparent' }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Rút tiền</Breadcrumb.Item>
            <Breadcrumb.Item active>Cài đặt rút tiền</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <Card border="light" className="shadow-sm">
        <Card.Header>
          <h5 className="mb-0">Mức rút tối thiểu về ngân hàng</h5>
          <div className="small text-muted mt-1">
            App và web lấy mức này từ parameters. Rút về ví chính không áp dụng.
          </div>
        </Card.Header>
        <Card.Body>
          <Form.Label className="small mb-1">Số tiền tối thiểu (đ)</Form.Label>
          <div className="d-flex gap-2" style={{ maxWidth: 420 }}>
            <Form.Control
              type="number"
              min={1}
              max={MAX_AMOUNT}
              value={amountInput}
              disabled={!loaded || saving}
              onChange={(e) => {
                setAmountInput(e.target.value)
                setError('')
                setSaved(false)
              }}
            />
            <Button
              variant="primary"
              onClick={onSave}
              disabled={!loaded || saving}
            >
              {saving ? 'Đang lưu...' : 'Lưu'}
            </Button>
          </div>
          <div className="small text-muted mt-2">
            Đang áp dụng: {loaded ? `${Number(savedAmount).toLocaleString('vi-VN')} đ` : 'Đang tải...'}
          </div>
          {error ? <div className="small text-danger mt-1">{error}</div> : null}
          {saved ? <div className="small text-success mt-1">Đã lưu. Lần mở parameters tiếp theo sẽ dùng mức mới.</div> : null}
        </Card.Body>
      </Card>
    </>
  )
}
